import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "no-gutters row" }
const _hoisted_2 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" My Organization: ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Total Sold: ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Total Sold Value: ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Total Purchased: ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Total Purchased Value: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_loading = _resolveComponent("v-loading")!
  const _component_line_chart = _resolveComponent("line-chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading || _ctx.meLoading)
      ? (_openBlock(), _createBlock(_component_v_loading, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, [
              _hoisted_3,
              _createElementVNode("b", null, _toDisplayString(_ctx.userOrg), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_4,
              _createElementVNode("b", null, _toDisplayString(_ctx.totalSoldCount), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_5,
              _createElementVNode("b", null, _toDisplayString(_ctx.totalSoldAmt), 1)
            ])
          ]),
          _createVNode(_component_line_chart, { "chart-data": _ctx.combinedSoldItemData }, null, 8, ["chart-data"]),
          _createElementVNode("div", null, [
            _createElementVNode("p", null, [
              _hoisted_6,
              _createElementVNode("b", null, _toDisplayString(_ctx.totalPurchasedCount), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_7,
              _createElementVNode("b", null, _toDisplayString(_ctx.totalPurchasedAmt), 1)
            ])
          ]),
          _createVNode(_component_line_chart, { "chart-data": _ctx.combinedPurchasedItemData }, null, 8, ["chart-data"])
        ]))
  ]))
}